<template>
<div class="container mb-4 p-sm-3 col-md-8">
  <h1>{{ eventKindText }}登録確認画面</h1>
  <p>登録内容をご確認下さい。内容にお間違えがなければ、新規{{ eventKindText }}開催申請ボタンを押して下さい</p>
  <p>
    <span class="attention">※</span>必須
  </p>
  <form class="mb-5 bg-faded p-4" method="post" @submit.prevent="submit()">

    <slot :item="eventForm" :endDate="endDate" :fullAddress="fullAddress"/>

    <div class="btn-group" role="group" aria-label="group">
      <router-link :to="inputPath" class="btn btn-outline-info btn-lg">修正する</router-link>
      <button type="submit" class="btn btn-primary btn-lg" :disabled="isDisabled">新規{{ eventKindText }}開催申請</button>
    </div>
    <div class="attention text-left my-2">事務局承認後に掲載となります。(通常中3営業日)</div>
  </form>
  <p class="text-right mt-5">
    <router-link to="/mypage">マイページへのリンク</router-link>
  </p>
</div>
</template>

<script>
import common from 'util/common.js'
import lecturer from 'util/lecturer.js'
export default {
  data () {
    return {
      isDisabled: false
    }
  },
  computed: {
    eventForm () {
      return this.$store.state.eventForm
    },
    fullAddress () {
      return common.fullAddress(this.eventForm.venue)
    },
    endDate () {
      return common.parseDateToSendAPI(this.eventForm.end_date)
    },
    inputPath () {
      return {
        path: '/input',
        query: this.$route.query
      }
    },
    eventKindText () {
      return common.eventKindTextFromPath(this)
    }
  },
  methods: {
    submit () {
      this.isDisabled = true
      lecturer.sendEvent(this, !this.$route.query.id ? 'apply' : 'reapply')
    }
  }
}
</script>



// WEBPACK FOOTER //
// ConfirmBase.vue?67e469bb